// Safari treats its text-field focus zoom separately from manual pinch zoom.
// Apply this workaround only to modern iPhone Safari, never Android or a
// native WKWebView, where a maximum scale could also restrict manual zoom.
export default function installWorkoutSafariViewport() {
  const noop = () => {};
  const agent = window.navigator.userAgent || '';
  const version = agent.match(/\bOS (\d+)[_\d]* like Mac OS X/);
  const safari = /iPhone|iPod/.test(agent)
    && /AppleWebKit\//.test(agent)
    && /Version\//.test(agent)
    && /Safari\//.test(agent)
    && !/CriOS|FxiOS|EdgiOS|OPiOS|GSA\//.test(agent)
    && version && Number(version[1]) >= 10;
  if (!safari || document.documentElement.classList.contains('native-app')
    || window.Capacitor?.isNativePlatform?.()) return noop;

  const viewport = document.querySelector('meta[name="viewport"]');
  const original = viewport?.getAttribute('content');
  if (!viewport || !original) return noop;

  // Do not reset the user's current zoom or disable user scaling. Keep every
  // existing viewport option, changing only Safari's automatic focus limit.
  const options = original.split(/[,;]/).map(value => value.trim()).filter(Boolean);
  const content = [...options.filter(value => !/^maximum-scale\s*=/i.test(value)), 'maximum-scale=1'].join(', ');
  viewport.setAttribute('content', content);
  return () => {
    // Another page/feature may have taken ownership while this page unmounted.
    if (viewport.isConnected && viewport.getAttribute('content') === content) {
      viewport.setAttribute('content', original);
    }
  };
}
